(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define(factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/***/ function(module, exports, __webpack_require__) {

	exports.parse = __webpack_require__(/*! ./parse */ 2);
	exports.stringify = __webpack_require__(/*! ./stringify */ 3);

/***/ },
/* 1 */
/*!***********************!*\
  !*** ./src/extend.js ***!
  \***********************/
/***/ function(module, exports, __webpack_require__) {

	/**
	 * A utility method to `extend` obj2 to obj1
	 *
	 * @param {Object} dest 
	 * @param {Object} source
	 */
	module.exports = function(dest, source) {
	  var keys = Object.keys(source);

	  keys.forEach(function(key) {
	    dest[key] = source[key];
	  });

	  return dest;
	}

/***/ },
/* 2 */
/*!**********************!*\
  !*** ./src/parse.js ***!
  \**********************/
/***/ function(module, exports, __webpack_require__) {

	var extend = __webpack_require__(/*! ./extend */ 1);

	module.exports = function(query, options) {
	  // This function does not accept primitives and functions
	  if (typeof query !== 'string') {
	    throw new Error('Provided query must be a string');
	  }

	  // Our resulting object
	  var result = {};
	  var _defaults = { decode: true };

	  // We don't have to `extend`
	  // if the consumer did not provide  any option
	  if ( options !== undefined ) {
	    extend(_defaults, options);
	  }
	  options = _defaults;

	  // First, we'll try to remove the prepending `?`,
	  // then split each key=value separated by &.
	  var splitted = query.replace(/^\?/, '').split('&');

	  // Using native loops instead of `map` or `forEach`
	  // http://jsperf.com/native-map-versus-array-looping
	  // Now we'll iterate through the splitted keyz
	  for ( var i = 0; i < splitted.length; i++ ) {
	    // Where the result of the split
	    // `x=y` would be ['x', 'y'], assigning it
	    // like this.x = 'y';
	    var kv = splitted[i].split('=');
	    result[kv[0]] = options.decode ? decodeURIComponent(kv[1]) : kv[1];
	  };

	  return result;
	}

/***/ },
/* 3 */
/*!**************************!*\
  !*** ./src/stringify.js ***!
  \**************************/
/***/ function(module, exports, __webpack_require__) {

	var extend = __webpack_require__(/*! ./extend */ 1);

	module.exports = function(query, options) {
	  // This function does not accept primitives and functions
	  if (query == null || typeof query !== 'object') {
	    throw new Error('Provided query must be an object');
	  }

	  var result = ''; // Our resulting string
	  var keys = Object.keys(query);
	  // All options (`prepend` and `encode` are `true` by default)
	  var _defaults = { prepend: true, encode: true };

	  // We don't have to `extend` if the consumer did not provide
	  // any option, to avoid overhead
	  if ( options !== undefined ) {
	    extend(_defaults, options);
	  }
	  options = _defaults;

	  keys.forEach(function(key, i) {
	    var _value = query[key]; // Just our stringified JSON
	    var value = options.encode ? encodeURIComponent(_value) : _value;
	    
	    // Prepends the ampsersand separator `&` for
	    // each key except the first key
	    var _prepend = (i > 0 ? '&' : '');

	    result += _prepend + key + '=' + value;
	  });

	  return (options.prepend ? '?' : '') + result;
	}

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** qs.js
 **/